"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _menuItem = _interopRequireDefault(require("./menu-item"));
var _menuTitle = _interopRequireDefault(require("./menu-title"));
var _siderMenuBadge = _interopRequireDefault(require("../mixins/sider-menu-badge"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = {
  name: 'iMenuSideSubmenu',
  components: {
    iMenuSideItem: _menuItem.default,
    iMenuSideTitle: _menuTitle.default
  },
  mixins: [_siderMenuBadge.default],
  props: {
    menu: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
exports.default = _default;